const siteConfig = {
  brandName: "partisbella",
  shortName: "partisbella",
  tagline: "Flavor brings us home.",
  description:
    "Small-batch spices, generous blends, and kitchen-ready gifts made to bring warmth to everyday cooking.",
  promotion: {
    text: "Free standard shipping on orders $49+.",
    link: "/shop",
  },
  newsletter: {
    title: "Fresh ideas, delivered.",
    description:
      "Seasonal recipes, practical pantry notes, and first tastes of new small-batch blends.",
  },
  searchPlaceholder: "What are you cooking?",
  routes: {
    account: "/account",
    wishlist: "/wishlist",
    cart: "/cart",
  },
  contact: {
    email: "area@partisbella.shop",
    hours: "Monday–Friday, 9am–5pm CT",
    address: {
      line1: "Colón 124",
      district: "Centro",
      postalCode: "48740",
      city: "El Grullo",
      region: "Jal.",
      country: "MX",
    },
  },
  shipping: {
    freeShippingThreshold: 49,
    currency: "USD",
    currencySymbol: "$",
    standardDelivery: "3–6 business days",
    expressDelivery: "2 business days",
    message: "Free standard shipping on orders $49+.",
  },
  social: {},
  navigation: [
    { label: "Shop", path: "/shop" },
    { label: "Best Sellers", path: "/shop?collection=best-sellers" },
    { label: "Gift Sets", path: "/shop?category=gift-sets" },
    { label: "Quick Order", path: "/express-order" },
    { label: "Recipes", path: "/recipes" },
    { label: "Stores", path: "/locations" },
    { label: "Our Story", path: "/about" },
    {
      label: "More",
      path: "/faq",
      children: [
        { label: "FAQ", path: "/faq" },
        { label: "Privacy", path: "/privacy" },
        { label: "Cookie Policy", path: "/cookies" },
        { label: "Terms", path: "/terms" },
        { label: "Returns", path: "/returns" },
        { label: "Delivery", path: "/delivery" },
      ],
    },
  ],
  footerLinks: [
    {
      title: "Shop",
      links: [
        { label: "All Spices", path: "/shop" },
        { label: "Blends", path: "/shop?category=blends" },
        { label: "Baking", path: "/shop?category=baking" },
        { label: "Gift Sets", path: "/shop?category=gift-sets" },
      ],
    },
    {
      title: "Help",
      links: [
        { label: "Contact", path: "/contact" },
        { label: "Shipping & Delivery", path: "/delivery" },
        { label: "Returns", path: "/returns" },
        { label: "FAQ", path: "/faq" },
      ],
    },
    {
      title: "Company",
      links: [
        { label: "Our Story", path: "/about" },
        { label: "Recipes", path: "/recipes" },
        { label: "Privacy", path: "/privacy" },
        { label: "Terms", path: "/terms" },
        { label: "Cookie Policy", path: "/cookies" },
      ],
    },
    {
      title: "Discover",
      links: [
        { label: "Quick Order", path: "/express-order" },
        { label: "Store Locator", path: "/locations" },
        { label: "Favorites", path: "/wishlist" },
        { label: "My Account", path: "/account" },
      ],
    },
  ],
};

export default siteConfig;
